<template>
  <section v-if="pax && pax['covid19_portal'] && pax['covid19_portal']['1']">
    <Title :title-name="titlePage.titleName" :title-link="titlePage.titleLink" />
    <div class="my-flight-updates">
      <section class="mt-4">
        <ul class="list-news-flight">
          <template v-for="(cmt, k) in Cmtpax">
            <li v-if="cmt.sms_with_content == 1 && cmt.status == 2" :key="k" class="item-news-flight">
              <div class="container">
                <!-- eslint-disable-next-line vue/no-deprecated-filter -->
                <h2 class="title-news">Update {{ cmt.created | datetime() }}</h2>
                <div class="content-news" @click="openNewsFlight(k, cmt.id, cmt.has_read)">
                  <div>
                    <div v-if="!sortDescription[k]" v-html="cmt.content.substring(0, 100) + '...'"></div>
                    <div v-else v-html="cmt.content"></div>
                  </div>
                  <div class="text-right">
                    <span v-if="!sortDescription[k]" class="cursor">{{ pax['covid19_portal'][1].READ_MORE }}</span>
                    <span v-else class="cursor">{{ pax['covid19_portal'][1].READ_LESS }}</span>
                  </div>
                </div>
              </div>
            </li>
          </template>
        </ul>
      </section>
    </div>
  </section>
</template>

<script>
import '@/assets/scss/modules/MyFlightUpdates.scss'
import { mapGetters } from 'vuex'
import Title from '@/components/Title/index'
import moment from 'moment'
export default {
  name: 'MyFlightUpdates',
  components: { Title },
  filters: {
    datetime: function (date) {
      return moment(date).format('DD-MM-YYYY')
    }
  },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      sortDescription: [],
      titlePage: {}
    }
  },
  computed: {
    ...mapGetters({
      Cmtpax: 'MessagesList/Cmtpax'
    })
  },
  watch: {
    title: function (el) {
      if (el && el.MyFlightUpdates) {
        this.titlePage = el.MyFlightUpdates
      }
    }
  },
  mounted() {
    if (this.title && this.title.MyFlightUpdates) {
      this.titlePage = this.title.MyFlightUpdates
    }
    this.$store.dispatch('MessagesList/getCmtpax')
  },
  methods: {
    openNewsFlight: function (k, id, hasRead) {
      let sortList = []
      if (this.sortDescription[k]) {
        sortList[k] = false
      } else {
        sortList[k] = true
      }
      this.sortDescription = sortList
      if (hasRead > 0) {
        this.$store.dispatch('MessagesList/updateMessage', id)
      }
    }
  }
}
</script>
